export type SettlementKind = "Charge" | "Deduction";
export type SettlementLine = {
  systemId: string;
  directUnitCost: number | null;
  quantity: number | null;
  settlementAmountEditable: boolean;
  lineMatched: boolean;
};
export type SettlementPlan =
  | { action: "create"; amount: number }
  | { action: "update"; systemId: string; directUnitCost: number };

export function parseSettlementMagnitude(kind: SettlementKind, raw: string): number {
  const normalized = raw.trim().replace(",", ".");
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) {
    throw new Error("Podaj dodatnią kwotę z maksymalnie dwoma miejscami po przecinku.");
  }
  const numeric = Number(normalized);
  const cents = Math.round(numeric * 100);
  if (!Number.isFinite(numeric) || !Number.isSafeInteger(cents) || cents < 1) {
    throw new Error("Podaj poprawną kwotę większą od zera.");
  }
  return (kind === "Deduction" ? -1 : 1) * cents / 100;
}

export function planSettlementChange(
  kind: SettlementKind, lines: SettlementLine[], value: number, allowCreate: boolean,
): SettlementPlan {
  const cents = Math.round(value * 100);
  const exact = Number.isFinite(value) && Number.isSafeInteger(cents) &&
    Math.abs(value - cents / 100) < 0.0000001;
  if (!exact || (kind === "Charge" ? cents < 1 : cents > -1)) {
    throw new Error(kind === "Charge"
      ? "Kwota obciążenia musi być dodatnia."
      : "Kwota odliczenia musi być ujemna.");
  }
  if (lines.length > 1) {
    throw new Error("Kilka wierszy tego samego typu — edycja jest możliwa w BC.");
  }
  if (lines.length === 0) {
    if (!allowCreate) throw new Error("Ręczne dodawanie tego wiersza jest zablokowane.");
    return { action: "create", amount: value };
  }
  const line = lines[0];
  if (!line.settlementAmountEditable || line.lineMatched || Number(line.quantity ?? 1) !== 1) {
    throw new Error("BC nie pozwala zmienić kwoty tego wiersza.");
  }
  return { action: "update", systemId: line.systemId, directUnitCost: value };
}
